import React, { useState } from 'react';
import LazyLoad from 'react-lazyload';
import { Spin } from 'antd';

const LazyImage = ({ 
  src, 
  alt, 
  className, 
  height = 200, 
  offset = 100, 
  placeholder = null,
  onLoad,
  onError,
  ...props 
}) => {
  const [imageLoaded, setImageLoaded] = useState(false);
  const [imageError, setImageError] = useState(false);

  const handleLoad = () => {
    setImageLoaded(true);
    if (onLoad) onLoad();
  };

  const handleError = () => {
    setImageError(true);
    if (onError) onError();
  };

  const renderPlaceholder = () => {
    if (placeholder) return placeholder;
    return (
      <div 
        style={{ 
          height, 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center',
          backgroundColor: '#f5f5f5',
          borderRadius: '8px'
        }}
      >
        <Spin size="small" />
      </div>
    );
  };

  return (
    <LazyLoad height={height} offset={offset} once>
      <div style={{ position: 'relative' }}>
        {!imageLoaded && !imageError && renderPlaceholder()}
        <img
          src={src}
          alt={alt}
          className={className}
          style={{
            display: imageLoaded ? 'block' : 'none',
            width: '100%',
            height: 'auto'
          }}
          onLoad={handleLoad}
          onError={handleError}
          {...props}
        />
        {imageError && (
          <div 
            style={{ 
              height, 
              display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'center',
              backgroundColor: '#f5f5f5',
              borderRadius: '8px',
              color: '#999'
            }}
          >
            Image not available
          </div>
        )}
      </div>
    </LazyLoad>
  );
};

export default LazyImage; 